import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import './chunk-590a6902.js';
import './chunk-ea9bc877.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { S as Select } from './chunk-40f06d9c.js';
export { S as BSelect } from './chunk-40f06d9c.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Select);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/select.js
// module id = 01Ww
// module chunks = 0 1